import axios, { type AxiosInstance } from 'axios';

export class ApiBase {
	public api: AxiosInstance;

	constructor (baseURL: string) {
		this.api = axios.create({
			baseURL,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json'
			}
		});

		this.api.interceptors.response.use((response) => {
			return response;
		}, (error) => {
			if (["FST_JWT_BAD_REQUEST", "AUTHENTICATION_ERROR"].includes(error?.response?.data?.code) && typeof window !== 'undefined') {
				window.location.href = '/auth';
			}
			const redirectSudomain = error?.response?.data?.redirect;
			if (redirectSudomain && typeof window !== 'undefined') {
				const url = new URL(window.location.href);
				const currentSubdomain = url.hostname?.split('.')?.[0];
				window.location.href = `${ url.origin?.replace(currentSubdomain, redirectSudomain) }/uilib/listings`;
			}
			console.error("Request error", error);

			throw error;
		});

		/* try {
			const result = await callback(data);
			return result;
		}
		catch (ex: any) {
			if (["FST_JWT_BAD_REQUEST", "AUTHENTICATION_ERROR"].includes(ex?.response?.data?.code) && window?.location?.href) {
				window.location.href = '/auth';
			}
			const redirectSudomain = ex?.response?.data?.redirect;
			if (redirectSudomain) {
				const url = new URL(window.location.href);
				const currentSubdomain = url.hostname?.split('.')?.[0];
				window.location.href = `${ url.origin?.replace(currentSubdomain, redirectSudomain) }/uilib/listings`;
			}
			console.error("Mutation error", ex);
			showToast({ title: 'Error', description: ex.message || "Something went wrong", type: 'error' });
			return null as RetType;
		} */
	}
}
